import type { ThemeClasses } from "../types";

interface CompanyFiltersProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  selectedStatus: string;
  searchQuery: string;
  onStatusChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  t: (key: string) => string;
}

export function CompanyFilters({
  themeClasses,
  isDarkMode,
  selectedStatus,
  searchQuery,
  onStatusChange,
  onSearchChange,
  t,
}: CompanyFiltersProps) {
  const selectClassName = `px-3 py-2 ${
    isDarkMode ? "bg-dark-card" : "bg-gray-50"
  } border ${themeClasses.cardBorder} rounded-lg ${
    themeClasses.text
  } text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 pr-8`;
  return (
    <div className="flex items-center space-x-2">
      {/* Search */}

      <div className="relative">
        <i
          className={`ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 ${themeClasses.textSecondary} text-sm`}
        ></i>
        <input
          type="text"
          placeholder={t("companies.searchCompanies")}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={`pl-10 pr-4 py-2 ${
            isDarkMode ? "bg-dark-card" : "bg-gray-50"
          } border ${themeClasses.cardBorder} rounded-lg ${
            themeClasses.text
          } placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-sm w-80`}
        />
      </div>

      {/* Status Filter */}
      <div className="min-w-[150px]">
        <select
          value={selectedStatus}
          onChange={(e) => onStatusChange(e.target.value)}
          className={selectClassName}
        >
          <option value="all">{t("companies.allStatuses") || "Todos los estatus"}</option>
          <option value="jXmjzHcBD5E1J0wjwHzq">{t("companies.active") || "Activa"}</option>
          <option value="Y2aD7bE1fF6jM3kO9hP5">{t("companies.inactive") || "Suspendida"}</option>
        </select>
      </div>
    </div>
  );
}
